import type { InferredEntity } from '@sites/entity-migrator';
import { createVersionedEntityWithDefaults } from '@sites/entity-migrator';

import { tabDefaultV0Schema } from './v0';
import { migrateTabV0ToV1, tabDefaultV1Schema } from './v1';

export const DefaultTabEntityVersionedSchema = createVersionedEntityWithDefaults({
    versionMap: {
        0: { schema: tabDefaultV0Schema },
        1: { schema: tabDefaultV1Schema, up: migrateTabV0ToV1 },
    },
    latestVersion: 1,
});
const DefaultTabEntitySchema = DefaultTabEntityVersionedSchema.latestSchema;
export { DefaultTabEntitySchema };

export type DefaultTab = InferredEntity<typeof DefaultTabEntityVersionedSchema>;
